import { render, staticRenderFns } from "./brexDataBanner.vue?vue&type=template&id=0713b0a0"
import script from "./brexDataBanner.vue?vue&type=script&lang=js"
export * from "./brexDataBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports